import { PromiseType } from "utility-types";

import { Action } from "../reactive/action";
import { baseRequest } from "../request";
import { API_URL } from "../../lib";

// without this a hung connection holds the refresh open indefinitely and the retry
// schedule never gets to run. 10s also bounds how often 401-triggered joins can force attempts.
export const REFRESH_REQUEST_TIMEOUT_MS = 10000;

let inFlight: AbortController | null = null;

// A sign-in calls this before its own request goes out. A refresh still on the wire carries the old
// session's cookie, and its reply's `Set-Cookie` could land after the sign-in's and put that session
// back; ignoring the reply's body cannot undo the cookie. An abandoned request is never answered, so
// it reports no reply and the refresh schedule retries with whatever cookie the browser then holds.
export const abortRefreshInFlight = (): void => {
  inFlight?.abort();
};

export class RefreshTokenAction extends Action<void, PromiseType<ReturnType<typeof baseRequest>>> {
  static readonly instance = Object.freeze(new RefreshTokenAction());

  private constructor() {
    super(() => {
      const controller = new AbortController();
      inFlight = controller;
      return baseRequest({
        method: "post",
        url: `${API_URL}/v1/web/identity-refresh-token-submit`,
        data: {},
        timeout: REFRESH_REQUEST_TIMEOUT_MS,
        signal: controller.signal,
      }).finally(() => {
        if (inFlight === controller) inFlight = null;
      });
    });
  }
}
